<sf-card>
    <div class="d-flex gap-2">
        <div>
            <img
                class="avatar"
                [style.border-color]="staff.colour"
                [src]="staff.picture"
                style="max-width: 150px"
                [alt]="staff.fullName"
                [title]="staff.fullName" />
        </div>
        <div class="flex-fill">
            <div class="d-flex justify-content-between">
                <span class="fw-bold">
                    @if (staff.notes) {
                        <span [ngbTooltip]="staff.notes" container="body">
                            <fa-icon class="text-danger" [icon]="['fas', 'info-circle']" animation="beat"></fa-icon>
                        </span>
                    }
                    {{ staff.fullName }}
                </span>
                <span>
                    <small ngbTooltip="Staff ID" container="body" class="text-body-tertiary">#{{ staff.id }}</small>
                </span>
            </div>
            @if (staff.roles.length) {
                <div class="d-flex flex-wrap gap-1 my-2">
                    @for (role of staff.roles; track role.id) {
                        <span class="badge text-bg-info">{{ role.name }}</span>
                    }
                </div>
            }
            @if (staff.vehicle) {
                <div
                    class="p-2 my-2 bg-secondary border-secondary-subtle border-3 border text-dark rounded-2 small d-flex justify-content-between">
                    <p class="mb-0">
                        <fa-icon class="me-2" [icon]="['fas', 'car']"></fa-icon
                        ><span class="fw-bold">{{ staff.vehicle.registration }}</span>
                    </p>
                    <p class="mb-0 fst-italic">Since: {{ staff.vehicle.since | date: 'dd/MM/yyyy' }}</p>
                </div>
            }
            <p class="small mb-0 text-body-tertiary">Username: {{ staff.username }}</p>
            @if (staff.mobile && (staff.mobile | phoneNumber)) {
                <p class="small mb-0 text-body-tertiary">
                    Phone: <a href="tel:{{ staff.mobile | phoneNumber }}">{{ staff.mobile | phoneNumber }}</a>
                </p>
            }
            @if (staff.emailAddress) {
                <p class="small mb-0 text-body-tertiary">
                    Email: <a href="mailto:{{ staff.emailAddress }}">{{ staff.emailAddress }}</a>
                </p>
            }

            @if (staff.holidayEntitlement > 0) {
                <p class="small mb-0">
                    <span class="text-body-tertiary">Annual Leave:</span>
                    {{ staff.holidayEntitlementRemaining }} days remaining.
                </p>
            }
        </div>
    </div>
    <ng-container *sfCardFooter>
        <div class="d-flex justify-content-between">
            <div>
                <a sfButton color="primary" size="sm" routerLink="/staff/{{ staff.id }}">View</a>
                <a
                    sfButton
                    color="secondary"
                    size="sm"
                    tooltip="View Diary"
                    [routerLink]="['diary', 'calendar']"
                    [queryParams]="{ staffId: staff.id }"
                    icon="calendar"
                    >Diary</a
                >
            </div>
            <div>
                <button
                    sfButton
                    type="button"
                    size="sm"
                    color="info"
                    icon="bell"
                    (click)="openSendPushNotificationModal()"
                    tooltip="Send Push Notification to users device"
                    tooltipContainer="body"></button>
                @if (staff.mobile && (staff.mobile | phoneNumber)) {
                    <a
                        sfButton
                        type="button"
                        size="sm"
                        color="primary"
                        icon="phone-volume"
                        tooltip="Call {{ staff.mobile }}"
                        href="tel:{{ staff.mobile | phoneNumber }}"
                        >Call</a
                    >
                }
            </div>
        </div>
    </ng-container>
</sf-card>
